// LUCABU Nocturne — scripts (vanilla, sin dependencias)

function mtInitReveal() {
  var els = document.querySelectorAll('.mt-reveal');
  if (!els.length) return;
  if (!('IntersectionObserver' in window)) {
    els.forEach(function (el) { el.classList.add('mt-visible'); });
    return;
  }
  var obs = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        entry.target.classList.add('mt-visible');
        obs.unobserve(entry.target);
      }
    });
  }, { threshold: 0, rootMargin: '0px 0px -8% 0px' });
  els.forEach(function (el) { obs.observe(el); });
  // Red de seguridad: nada visible en pantalla puede quedarse oculto
  setTimeout(function () {
    document.querySelectorAll('.mt-reveal:not(.mt-visible)').forEach(function (el) {
      if (el.getBoundingClientRect().top < window.innerHeight * 1.25) {
        el.classList.add('mt-visible');
      }
    });
  }, 2000);
}

/* Contador animado (cifras de especificaciones) */
function mtFijaContador(el) {
  var destino = parseFloat(el.dataset.mtContador);
  var decimales = (String(el.dataset.mtContador).split('.')[1] || '').length;
  el.textContent = destino.toFixed(decimales) + (el.dataset.mtSufijo || '');
}

function mtInitContadores() {
  var nums = document.querySelectorAll('[data-mt-contador]');
  if (!nums.length) return;
  var sinMovimiento = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (sinMovimiento || !('IntersectionObserver' in window)) {
    nums.forEach(mtFijaContador);
    return;
  }
  nums.forEach(function (n) { n.textContent = '0' + (n.dataset.mtSufijo || ''); });
  var obs = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (!entry.isIntersecting) return;
      var el = entry.target;
      obs.unobserve(el);
      var destino = parseFloat(el.dataset.mtContador);
      var sufijo = el.dataset.mtSufijo || '';
      var decimales = (String(destino).split('.')[1] || '').length;
      var ini = null;
      var dur = 1400;
      function paso(t) {
        if (ini === null) ini = t;
        var p = Math.min((t - ini) / dur, 1);
        var val = destino * (1 - Math.pow(1 - p, 3));
        el.textContent = val.toFixed(decimales) + sufijo;
        if (p < 1) requestAnimationFrame(paso);
        else el.textContent = destino.toFixed(decimales) + sufijo;
      }
      requestAnimationFrame(paso);
    });
  }, { threshold: 0.6 });
  nums.forEach(function (n) { obs.observe(n); });
  // Red de seguridad: si algún contador no llegó a animarse, muestra su valor real
  setTimeout(function () {
    nums.forEach(function (n) {
      if (n.textContent.charAt(0) === '0' && parseFloat(n.dataset.mtContador) !== 0) {
        if (n.getBoundingClientRect().top < window.innerHeight * 1.25) mtFijaContador(n);
      }
    });
  }, 4000);
}

/* Reseñas: duplica la pista para bucle infinito perfecto */
function mtInitMarquee() {
  document.querySelectorAll('[data-mt-marquee]').forEach(function (pista) {
    if (pista.dataset.mtClonado) return;
    pista.dataset.mtClonado = '1';
    var originales = Array.prototype.slice.call(pista.children);
    originales.forEach(function (hijo) {
      var clon = hijo.cloneNode(true);
      clon.setAttribute('aria-hidden', 'true');
      pista.appendChild(clon);
    });
  });
}

/* Página de producto: galería, variantes, cantidad */
function mtInitProducto() {
  var raiz = document.querySelector('[data-mt-producto]');
  if (!raiz) return;

  /* ---- Galería ---- */
  var principal = raiz.querySelector('[data-mt-galeria-principal]');
  raiz.querySelectorAll('[data-mt-mini]').forEach(function (mini) {
    mini.addEventListener('click', function () {
      var src = mini.dataset.mtFull;
      if (!src || !principal) return;
      principal.style.opacity = 0;
      setTimeout(function () {
        principal.src = src;
        principal.style.opacity = 1;
      }, 180);
      raiz.querySelectorAll('[data-mt-mini]').forEach(function (m) { m.classList.remove('mt-activa'); });
      mini.classList.add('mt-activa');
    });
  });

  /* ---- Variantes ---- */
  var datos = raiz.querySelector('[data-mt-variantes]');
  var variantes = [];
  try { variantes = JSON.parse(datos ? datos.textContent : '[]'); } catch (e) { variantes = []; }

  var inputId = raiz.querySelector('[data-mt-variant-id]');
  var precioActual = raiz.querySelector('[data-mt-precio-actual]');
  var precioAntes = raiz.querySelector('[data-mt-precio-antes]');
  var boton = raiz.querySelector('[data-mt-add]');
  var nombreOpcion = raiz.querySelector('[data-mt-opcion-elegida]');
  var seleccion = {};

  function dinero(céntimos) {
    return (céntimos / 100).toLocaleString('es-ES', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' €';
  }

  function coincide(v) {
    return v.options.every(function (op, i) { return seleccion[i] === op; });
  }

  function actualiza() {
    var v = variantes.find(coincide);
    if (!v) return;
    if (inputId) inputId.value = v.id;
    if (precioActual) precioActual.textContent = dinero(v.price);
    if (precioAntes) {
      if (v.compare_at_price && v.compare_at_price > v.price) {
        precioAntes.textContent = dinero(v.compare_at_price);
        precioAntes.style.display = '';
      } else {
        precioAntes.style.display = 'none';
      }
    }
    if (boton) {
      if (v.available) {
        boton.disabled = false;
        boton.textContent = boton.dataset.mtTexto || 'Añadir a la cesta';
      } else {
        boton.disabled = true;
        boton.textContent = 'Agotado';
      }
    }
    /* imagen de la variante */
    if (v.featured_image && principal) {
      principal.style.opacity = 0;
      setTimeout(function () { principal.src = v.featured_image; principal.style.opacity = 1; }, 180);
    }
  }

  raiz.querySelectorAll('[data-mt-swatch]').forEach(function (sw) {
    sw.addEventListener('click', function () {
      var idx = parseInt(sw.dataset.mtOpcionIndex, 10);
      seleccion[idx] = sw.dataset.mtValor;
      raiz.querySelectorAll('[data-mt-swatch][data-mt-opcion-index="' + idx + '"]').forEach(function (s) {
        s.classList.remove('mt-swatch-activo');
      });
      sw.classList.add('mt-swatch-activo');
      if (nombreOpcion) nombreOpcion.textContent = sw.dataset.mtNombre || sw.dataset.mtValor;
      actualiza();
    });
  });

  /* selección inicial desde los swatches ya marcados */
  raiz.querySelectorAll('[data-mt-swatch].mt-swatch-activo').forEach(function (sw) {
    seleccion[parseInt(sw.dataset.mtOpcionIndex, 10)] = sw.dataset.mtValor;
  });

  /* ---- Cantidad ---- */
  var ctrl = raiz.querySelector('[data-mt-cantidad]');
  if (ctrl) {
    var campo = ctrl.querySelector('input');
    ctrl.querySelector('[data-mt-menos]').addEventListener('click', function () {
      campo.value = Math.max(1, (parseInt(campo.value, 10) || 1) - 1);
    });
    ctrl.querySelector('[data-mt-mas]').addEventListener('click', function () {
      campo.value = (parseInt(campo.value, 10) || 1) + 1;
    });
  }
}

document.addEventListener('DOMContentLoaded', function () {
  mtInitReveal();
  mtInitContadores();
  mtInitMarquee();
  mtInitProducto();
});
